// ProtectedRoute.js
import { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "./AuthContext";
import { xorDecrypt } from "../encrypt";


const ProtectedRoute = ({ children }) => {
  const { state } = useContext(AuthContext);
  const { isAuthenticated, username } = state;
const location = useLocation();
const path = location.pathname;
const enrollmentStatus = xorDecrypt(localStorage.getItem("enrollmentStatus"));

//console.log("Raw enrollmentStatus from localStorage:", localStorage.getItem("enrollmentStatus"));
//console.log("Decrypted enrollmentStatus:", xorDecrypt(enrollmentStatus));
//console.log("isAuthenticated:", isAuthenticated);

if (!localStorage.getItem("isAuthenticated")) {
  return <Navigate to="/login" />;
}

if ((enrollmentStatus === 'false')) {
  //console.log("Redirecting to home because enrollmentStatus is true");
  return <Navigate to="/" />;
}

//console.log("Returning children");
return children;

};

export default ProtectedRoute;
